import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { get, includes, isEmpty, debounce, size } from 'lodash';
import { onlyUpdateForKeys } from 'recompose';
import { VXSpotlight } from 'oecd-visions';
import { spotlightTreeEngine } from '../../../utils/index';
import { VXCollapsibleBox } from '../../visions/vx-collapsible-box';
import { VXFilterTree } from '../../visions/vx-filter-tree';
import { VXBadge } from '../../visions/vx-badge';
import messages from '../../../utils/messages';

class _FacetItem extends Component {
  constructor(props) {
    super(props);
    this._onFacetSpotlightChange = debounce(props.onFacetSpotlightChange, 50);
  }

  render() {
    const {
      facet,
      intl,
      spotlight,
      selectedFacetsCount,
      isExpanded,
      isFilterable,
      onFacetSelectionChange,
      onFilterNodeExpand,
      onFilterNodeCollapse,
      onFacetToggleCollapse,
    } = this.props;
    const { data, conf } = facet;
    const { formatMessage } = intl;
    if (isEmpty(data)) {
      return null;
    }

    return (
      <VXCollapsibleBox
        title={
          <div>
            <FormattedMessage id={conf.intl.title}/>
            {selectedFacetsCount > 0 && <VXBadge>{selectedFacetsCount}</VXBadge>}
          </div>
        }
        isExpanded={isExpanded}
        onToggleCollapse={() => onFacetToggleCollapse(conf.key)}
      >
        {isFilterable &&
        <VXSpotlight
          term={get(spotlight, 'term', '')}
          changeSpotlight={change => this._onFacetSpotlightChange(conf.key, change)}
          hasClearAll={true}
          placeholder={formatMessage(messages.spotlightPlaceholder)}
          fields={{
            'label': {
              id: 'label',
              accessor: 'label',
              isSelected: true,
            },
          }}
        />}
        <VXFilterTree
          isTree={get(conf, 'isTree', false)}
          contents={spotlightTreeEngine(spotlight, data)}
          onNodeClick={node => onFacetSelectionChange(conf, node)}
          onNodeCollapse={node => onFilterNodeCollapse(conf.key, node)}
          onNodeExpand={node => onFilterNodeExpand(conf.key, node)}
        />
      </VXCollapsibleBox>
    )
  }
}

export const FacetItem = onlyUpdateForKeys(
  ['isExpanded', 'facet', 'spotlight']
)(_FacetItem);



// WEBPACK FOOTER //
// ./src/views/recalls-list/facets/facet-item.js